<template>
  <modal
    title="New Price Reference"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="py-6">
      <div>
        <label class="label">Reference Name:</label>
        <input
          type="text"
          class="input"
          placeholder="Enter"
          v-model="priceReference.referenceName"
        />
      </div>
      <div class="">
        <label class="label">Default Loyalty:</label>
        <el-select
          v-model="priceReference.defaultLoyalty"
          @change="getDiscountValue"
          placeholder="Select"
        >
          <el-option
            v-for="scheme in loyaltySchemes"
            :key="scheme.id"
            :label="scheme.loyaltyCategory"
            :value="scheme.loyaltyCategory"
          >
          </el-option>
        </el-select>
      </div>
      <div class="mt-4">
        <label class="label">Discount (%)</label>
        <input
          type="number"
          class="input"
          placeholder="Enter"
          @keypress="isNumber($event)"
          v-model="priceReference.discount"
          disabled
        />
      </div>
      <div class="actions pt-4 flex justify-between">
        <div class="cursor-pointer" @click="closeModal">
          <p>Cancel</p>
        </div>
        <div>
          <primary-button
            buttonText="Save"
            :loading="loading"
            @click="submit"
          />
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    priceReferences: {
      required: false,
    },
    selectedPriceReference: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      priceReference: {
        referenceName: "",
        defaultLoyalty: "",
        discount: 0,
      },
      loyaltySchemes: [],
    };
  },
  watch: {
    selectedPriceReference(val) {
      this.priceReference = { ...val };
    },
  },
  mounted() {
    this.getAllLoyaltySchemes();
  },
  methods: {
    closeModal() {
      this.priceReference = {
        referenceName: "",
        defaultLoyalty: "",
        discount: 0,
      };
      this.$emit("close-modal");
    },
    async submit() {
      let payload = {};
      if (this.selectedPriceReference) {
        let updatedPriceReferences = [...this.priceReferences];
        let indexOfUpdatedPreference = this.priceReferences.indexOf(
          this.selectedPriceReference
        );
        updatedPriceReferences[indexOfUpdatedPreference] = this.priceReference;
        this.loading = true;
        payload = {
          payload: {
            setting: {
              priceReference: [...updatedPriceReferences],
            },
          },
        };
      } else {
        payload = {
          payload: {
            setting: {
              priceReference: [...this.priceReferences, this.priceReference],
            },
          },
        };
      }

      try {
        const response = await this.$_updatePriceReferenceSettings(payload);
        this.logResponse(response);
        this.generateToast("Success!", "success");
        this.$emit("created");
        this.closeModal();
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    async getAllLoyaltySchemes() {
      try {
        const response = await this.$_getAllLoyaltySchemes();
        this.logResponse(response);
        this.loyaltySchemes = response.data;
      } catch (error) {
        this.handleError(error);
      }
    },
    getDiscountValue() {
      let selectedLoyalty = this.loyaltySchemes.filter((scheme) => {
        return scheme.loyaltyCategory == this.priceReference.defaultLoyalty;
      });
      this.priceReference.discount = selectedLoyalty[0].discountRate;
    },
  },
};
</script>

<style scoped></style>
